import React, { useContext } from "react";
import { useHistory } from "react-router";
import { PermissionContext, RolePermissions } from "appContext";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";
import { pages } from "views/pages/manage/common/constant";
import commission from "assets/img/commission.png"


const ModuleCards = ({ setListVisible }) => {
    const history = useHistory();

    const CommissionSlabPermission = RolePermissions(
        useContext(PermissionContext),
        pages["commissionSlab"]["id"]
    );

    const cards = [
        ...(CommissionSlabPermission?.length
            ? [
                {
                    heading: "F+EC Commission slabs master",
                    subHeading: "Modify commission slabs for Sub-contractor F+EC",
                    icon: <img
                        src={commission}
                        height={49}
                        width={52}
                    />,
                    action: () => {
                        history.push("/admin/accounting/commissionSlab");
                    },
                },
            ]
            : []),
        ]

    return (
        <>
            <div className={`screen-cards-container`}>{getScreenCards(cards)}</div>
        </>
    );
};

export default ModuleCards;
